import { useEffect, useState } from "react";
import { Users, CalendarCheck, Megaphone, Sparkles, Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Dashboard() {
  const [clients, setClients] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [exporting, setExporting] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
    api.get(`/admin/appointments?date=${today}`).then((r) => setAppointments(r.data)).catch(() => {});
    api.get("/admin/campaigns").then((r) => setCampaigns(r.data)).catch(() => {});
  }, [today]);

  const exportWeekPdf = async () => {
    setExporting(true);
    try {
      const res = await api.get("/admin/appointments/export/pdf", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = `agenda_semana_${today}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Erro ao exportar o planning.");
    } finally { setExporting(false); }
  };

  const cards = [
    { label: "Agendamentos hoje", value: appointments.length, icon: CalendarCheck },
    { label: "Total de clientes", value: clients.length, icon: Users },
    { label: "Novas clientes (30 dias)", value: clients.filter((c) => new Date(c.created_at) > new Date(Date.now() - 30 * 86400000)).length, icon: Sparkles },
    { label: "Campanhas enviadas", value: campaigns.length, icon: Megaphone },
  ];

  return (
    <div data-testid="admin-dashboard-page">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-serif text-[#9B6179]">Painel Principal</h1>
        <button
          onClick={exportWeekPdf}
          disabled={exporting}
          data-testid="export-week-pdf-button"
          className="rounded-[2px] inline-flex items-center gap-2 bg-[#090708] text-[#E8C47A] px-4 py-2.5 text-xs tracking-wide uppercase hover:bg-[#6F3F55] transition-colors disabled:opacity-50"
        >
          <Download className="w-4 h-4" /> {exporting ? "Gerando..." : "Exportar Semana (PDF)"}
        </button>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {cards.map((c, i) => (
          <div key={i} className="bg-white rounded-[2px] p-5 shadow-sm border border-[#9B6179]/5" data-testid={`dashboard-kpi-${i}`}>
            <c.icon className="w-5 h-5 text-[#C5A059] mb-3" />
            <p className="text-2xl font-serif text-[#9B6179]">{c.value}</p>
            <p className="text-xs text-[#6F3F55] mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2px] p-5 shadow-sm border border-[#9B6179]/5">
        <p className="text-sm font-medium text-[#9B6179] mb-4">Agendamentos de hoje</p>
        {appointments.length === 0 ? (
          <p className="text-sm text-[#6F3F55]">Nenhum agendamento para hoje.</p>
        ) : (
          <div className="space-y-2">
            {appointments.map((a) => (
              <div key={a.id} className="flex justify-between text-sm border-b border-[#9B6179]/5 py-2" data-testid={`dashboard-appt-${a.id}`}>
                <span>{a.slot} — {a.client_name}</span>
                <span className="text-[#6F3F55]">{a.service_name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
